var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLabResult = function SvgLabResult(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "06.-Health-Screens\\uD83D\\uDC8A",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1801_DeletionRequest",
    transform: "translate(-20.000000, -490.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tele-Screen-List",
    transform: "translate(0.000000, 417.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 6,
    transform: "translate(0.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5132957,3 C21.3330185,3 22,3.79499677 22,4.77166271 L22,4.77166271 L22,19.2279491 C22,20.2050032 21.3330185,21 20.5132957,21 L20.5132957,21 L3.48670434,21 C2.66698149,21 2,20.2050032 2,19.2279491 L2,19.2279491 L2,4.77166271 C2,3.79499677 2.66698149,3 3.48670434,3 L3.48670434,3 Z M9.43585714,6.1015 L5.15014286,6.1015 L5.07327344,6.10805692 C4.902375,6.13833036 4.793,6.27114286 4.793,6.45864286 L4.793,6.45864286 L4.793,7.88721429 L4.79955692,7.96408371 C4.82983036,8.13498214 4.96264286,8.24435714 5.15014286,8.24435714 L5.15014286,8.24435714 L5.50728571,8.24435714 L5.50728571,15.8872143 L5.51310714,16.0355357 C5.58639286,16.9638214 6.343,17.6729286 7.293,17.6729286 C8.293,17.6729286 9.07871429,16.8872143 9.07871429,15.8872143 L9.07871429,15.8872143 L9.07871429,8.24435714 L9.43585714,8.24435714 L9.51272656,8.23780022 C9.683625,8.20752679 9.793,8.07471429 9.793,7.88721429 L9.793,7.88721429 L9.793,6.45864286 L9.78644308,6.38177344 C9.75616964,6.210875 9.62335714,6.1015 9.43585714,6.1015 L9.43585714,6.1015 Z M8.443,10.3515 L8.443,15.6365 C8.443,16.2665 7.948,16.7615 7.318,16.7615 C6.688,16.7615 6.193,16.2665 6.193,15.6365 L6.193,15.6365 L6.193,10.3515 L8.443,10.3515 Z M20,14.6015 L12,14.6015 L12,16.1015 L20,16.1015 L20,14.6015 Z M20,11.1015 L12,11.1015 L12,12.6015 L20,12.6015 L20,11.1015 Z M20.043,7.6015 L15.043,7.6015 L15.043,9.1015 L20.043,9.1015 L20.043,7.6015 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLabResult, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lab-result.87924a67.svg";
export { ForwardRef as ReactComponent };